import { useLocalStorage } from "../../../hooks/useLocalStorage.js";
import { useRPCContext } from "../../../contexts/RPCContext.js";
import { useEffect, useState } from "react";
//#region src/modules/FormBuilder/hooks/useFormSchema.ts
var makeLSKey = (formId) => `form_${formId}`;
/**
* We store Forms long term because they are unique by ID and never change
*/
function useFormSchema(formId) {
	const { rpcService } = useRPCContext();
	const [form, setForm] = useLocalStorage(makeLSKey(formId), void 0);
	const [loading, setLoading] = useState(!form && !!formId);
	useEffect(() => {
		if (!formId) return;
		if (!form || form?.id !== formId) {
			setLoading(true);
			rpcService.Forms.GetForm.v1.call({ formId }).then(({ data }) => setForm(data.form)).finally(() => setLoading(false));
		}
	}, [formId]);
	return {
		form,
		loading
	};
}
//#endregion
export { useFormSchema };

//# sourceMappingURL=useFormSchema.js.map